import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { UserRole } from '../enums/user-role';

export const LoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (!authService.isUserAuthenticated()) {
    return true;
  }

  if (authService.user().role === UserRole.SECURITY_MANAGER) {
    return router.navigateByUrl('/staff-scheduler');
  }
  return router.navigateByUrl('/dashboard');
};
